import getTag from './internals/getTag.js';
import { functionTags } from './internals/native.js';

function isFunction(value) {
    if (typeof value === 'function') {
        return true;
    }
    var tag = getTag(value);
    return functionTags.some(function (item) { return item === tag; });
}

export { isFunction as default };
